// src/services/AuthService.js

const API = '/api/login';

/**
 * Autentica al usuario en el sistema
 * @param {string} email 
 * @param {string} password 
 */
export const loginUser = async (email, password) => {
  try {
    const response = await fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      // Si el backend mandó "Credenciales inválidas" o similares
      throw new Error(data.error || "Error desconocido");
    }

    return data;
  } catch (error) {
    // Solo lanza el mensaje limpio para que el componente lo capture
    throw new Error(error.message);
  }
};